module.exports = __webpack_public_path__ + "static/img/zhuanxiang2.1ad06522.webp";